export default "__VITE_ASSET__C_rX_Uxb__"